// import React from 'react'
// import Logo from '../assets/logo1.png';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <>
//       <footer className='pt-5 pb-3'>
//         <div className='container'>

// <img src={Logo} className='footer-logo rounded-pill' alt='Footer Logo' />

// <div className='row'>

// <div className='col-lg-6 col-12 my-2'>

// <div className='d-md-flex justify-content-around text-muted my-3 fm-spartan' style={{fontSize: '1.1em'}}>
//   <p>9938888882<br />siddhabhairabi@gmail.com</p>
//   <p>Sankarpur Street,<br />Berhampur, Ganjam, Odisha, 760006</p>
// </div>
// {/* flex ends */}
//   <p className='text-muted fm-spartan'>&copy; Siddha Bhairabi Store. All Right Reserved. Developed By&nbsp;&nbsp;
//     <Link className='footer-text' to='https://www.digithack.in/' target='_blank'>Digit Hack Software Solutions</Link>
//   </p>

// </div>


// <div className='col-lg-6 d-flex'>
// <div>
// <p><Link className='footer-text' to='/'>Home</Link></p>
// <p><Link className='footer-text' to='/about'>About</Link></p>
// </div>
// <div className='ms-3'>
// <p><Link className='footer-text' to='/contact'>Contact</Link></p>
// <p><Link className='footer-text' to='/privacy-policy'>Privacy Policy</Link></p></div>
// </div>

// {/* <div className='col-lg-3'>
// </div> */}


// </div>
// {/* row ends */}


//         </div>
//       </footer>
//     </>
//   )
// }

// export default Footer





import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Logo from '../assets/hargharmart Logo.png';

const Footer = () => {
  return (
  <footer className="footer-section">
  <div className="container">
    <div className="row">

      {/* About */}
      <div className="col-lg-6 col-md-6 mb-3">
      <img src={Logo} className='footer-logo rounded-pill' alt='Footer Logo' />

        <p className="footer-text mb-3">
          Your trusted online grocery store for fresh fruits,
          vegetables, dairy products, snacks, beverages and
          daily essentials delivered to your doorstep.
        </p>

        <div className="social-icons">
          <a href="#"><FaFacebookF /></a>
          <a href="#"><FaInstagram /></a>
       
        </div>
      </div>

      {/* Quick Links */}
     <div className="col-lg-3 col-md-6 col-12 footer-col mb-3">
        <h5 className="footer-title">Quick Links</h5>

        <ul className="footer-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/privacy-policy">PrivacyPolicy</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>

      {/* Contact */}
   <div className="col-lg-3 col-md-6 col-12 footer-col mb-3">
        <h5 className="footer-title">Contact</h5>

        <p className="footer-contact">
          <FaMapMarkerAlt />Opp nyay nagar gate, jhusi, Prayagraj, 211019
        </p>

        <p className="footer-contact">
          <FaPhoneAlt /> +91 7398573394
        </p>

        <p className="footer-contact">
          <FaEnvelope /> support@hargharmart.com
        </p>
      </div>

    </div>

    <hr className="footer-line" />

    <div className="footer-bottom text-center">
      © {new Date().getFullYear()} HarGharMart. All Rights Reserved.
    </div>

  </div>
</footer>
  );
};

export default Footer;

